import { ApiService } from '../common/serviceBase';
import { URL_REPORTS } from '../common/apiUrl';

export class RelmodelosService {
    constructor() {
        this.service = new ApiService(`${URL_REPORTS}/relatorios`);
    }

    async getAll(rela_id) {
        const response = await this.service.get(`/${rela_id}/relmodelos`);
        return response.data;
    }

    async create(relm_id, data) {
        const response = await this.service.post(`/${relm_id}/relmodelos`, data);
        return response.data;
    }

    async update(rela_id, relm_id, data) {
        const response = await this.service.put(`/${rela_id}/relmodelos/${relm_id}`, data);
        return response.data;
    }

    async remove(rela_id, relm_id) {
        const response = await this.service.delete(`/${rela_id}/relmodelos/${relm_id}`);
        return response;
    }

    async get(rela_id, relm_id) {
        const response = await this.service.get(`/${rela_id}/relmodelos/${relm_id}`);
        return response.data;
    }
}